import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlFrontendButtonComponent } from '@app/core/wrappers/bl-frontend-button.component';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';
import { DialogData } from '../../form-dialog-base/form-dialog-base.component';
import { PleaseWaitComponent } from '../../please-wait/please-wait.component';
import { TranslocoModule } from '@jsverse/transloco';

const TRANSLATION_SCOPE = 'changeResponsibleWarningDialog';

@Component({
  selector: 'app-change-responsible-warning-dialog',
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <div>
        <div>
          <p>{{ t('youAreAboutToChangeResponsible') }}</p>
          <p>
            {{ t('changeInfoMessage') }}
          </p>
          <div class="flex justify-end mt-4 space-x-2">
            <bl-frontend-button [text]="'shared.close' | transloco" variant="secondary" (onclick)="close({})" />
          </div>
        </div>
      </div>
    </ng-container>
  `,
  standalone: true,
  providers: [DialogService, getTranslationProvider(TRANSLATION_SCOPE)],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BlFrontendButtonComponent,
    PleaseWaitComponent,
    TranslocoModule,
  ],
})
export class ChangeResponsibleWarningDialog extends TranslatableFormDialogBaseComponent {
  protected static override getTranslationScope(): string {
    return TRANSLATION_SCOPE;
  }

  protected static override getDialogConfig(
    translation: Record<string, string>,
  ): Omit<DynamicDialogConfig<DialogData>, 'data'> {
    return {
      header: translation.changeResponsibleUserQuestion,
      width: '450px',
      closable: false,
      closeOnEscape: false,
      draggable: false,
      modal: true,
    };
  }
}
